enum OpacityToken {
  Hidden = 0,
  Pressed = 0.75,
  Shadow = 0.16,
  Visible = 1,
}

enum ZIndexToken {
  Base = 1,
  FloatingContent = 10,
  Toast = 1000,
}

enum LayoutToken {
  ContentPaddingHorizontal = 24,
  ModalContentPaddingHorizontal = 32,
  ModalHeaderPadding = 18,
  OnboardingScreenHorizontalPadding = 30,
  OnboardingScreenTopPadding = 40,
  WebContentMaxWidth = 1000,
}

/* eslint-disable no-restricted-syntax -- literals starting with $ are restricted everywhere; except here where we define them once  */
enum ColorToken {
  AccentAqua = "$accent.aqua",
  AccentBlue = "$accent.blue",
  AccentLime = "$accent.lime",
  AccentPeriwinkle = "$accent.periwinkle",
  BackgroundDark = "$background.dark",
  ButtonAccentBlueActive = "$button.accent.blue.active",
  ButtonAccentCriticalActive = "$button.accent.critical.active",
  ButtonAccentLimeActive = "$button.accent.lime.active",
  ButtonPrimaryActive = "$button.primary.active",
  NeutralBackgroundPrimary = "$neutral.background.primary",
  NeutralBackgroundSecondary = "$neutral.background.secondary",
  NeutralLine = "$neutral.line",
  NeutralPrimary = "$neutral.primary",
  NeutralSecondary = "$neutral.secondary",
  NeutralTertiary = "$neutral.tertiary",
  NotificationCritical = "$notification.critical",
  NotificationCriticalBackground = "$notification.critical.background",
  NotificationCriticalBackgroundHover = "$notification.critical.background.hover",
  NotificationCriticalText = "$notification.critical.text",
  NotificationSuccess = "$notification.success",
  NotificationSuccessBackground = "$notification.success.background",
  NotificationSuccessText = "$notification.success.text",
  Primary10 = "$primary.10",
  Primary50 = "$primary.50",
  Primary90Variant = "$primary.90.variant",
  Primary100 = "$primary.100",
  Secondary5 = "$secondary.5",
  Secondary10 = "$secondary.10",
  Secondary50 = "$secondary.50",
  Secondary70 = "$secondary.70",
  TertiaryMarigoldBackground = "$tertiary.marigold.background",
  TertiaryMarigoldBase = "$tertiary.marigold.base",
  TertiaryMarigoldText = "$tertiary.marigold.text",
  TertiaryOrangeBackground = "$tertiary.orange.background",
  TertiaryOrangeBase = "$tertiary.orange.base",
  TertiaryOrangeText = "$tertiary.orange.text",
  TertiaryPlumBackground = "$tertiary.plum.background",
  TertiaryPlumText = "$tertiary.plum.text",
  Transparent = "$transparent",
}
/* eslint-enable no-restricted-syntax */

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const ColorTokenValues: Record<ColorToken, string> = {
  [ColorToken.AccentAqua]: "#00EBBF",
  [ColorToken.AccentBlue]: "#2266FF",
  [ColorToken.AccentLime]: "#D2FF7C",
  [ColorToken.AccentPeriwinkle]: "#6492F9",
  [ColorToken.BackgroundDark]: "#000000",
  [ColorToken.ButtonAccentBlueActive]: "#1B52CC",
  [ColorToken.ButtonAccentCriticalActive]: "#7E100A",
  [ColorToken.ButtonAccentLimeActive]: "#A8CC63",
  [ColorToken.ButtonPrimaryActive]: "#006661",
  [ColorToken.NeutralBackgroundPrimary]: "#FFFFFF",
  [ColorToken.NeutralBackgroundSecondary]: "#F9F9FA",
  [ColorToken.NeutralLine]: "#E6E8ED",
  [ColorToken.NeutralPrimary]: "#1E2026",
  [ColorToken.NeutralSecondary]: "#585D69",
  [ColorToken.NeutralTertiary]: "#B2B6C1",
  [ColorToken.NotificationCritical]: "#C61910",
  [ColorToken.NotificationCriticalBackground]: "#FAE9E8",
  [ColorToken.NotificationCriticalBackgroundHover]: "#EDDDDC",
  [ColorToken.NotificationCriticalText]: "#7F0A0A",
  [ColorToken.NotificationSuccess]: "#10C689",
  [ColorToken.NotificationSuccessBackground]: "#E8FAF4",
  [ColorToken.NotificationSuccessText]: "#0A7F58",
  [ColorToken.Primary10]: "#E7FDF9",
  [ColorToken.Primary100]: "#007F79",
  [ColorToken.Primary50]: "#4CA5A1",
  [ColorToken.Primary90Variant]: "#164356",
  [ColorToken.Secondary10]: "#DCE7FF",
  [ColorToken.Secondary5]: "#F4F7FF",
  [ColorToken.Secondary50]: "#647496",
  [ColorToken.Secondary70]: "#2D3C5A",
  [ColorToken.TertiaryMarigoldBackground]: "#FFEDBE",
  [ColorToken.TertiaryMarigoldBase]: "#FFC52E",
  [ColorToken.TertiaryMarigoldText]: "#775808",
  [ColorToken.TertiaryOrangeBackground]: "#FFDDBD",
  [ColorToken.TertiaryOrangeBase]: "#EF831F",
  [ColorToken.TertiaryOrangeText]: "#773E08",
  [ColorToken.TertiaryPlumBackground]: "#F9E0F0",
  [ColorToken.TertiaryPlumText]: "#653A54",
  [ColorToken.Transparent]: "transparent",
};

export { ColorToken, ColorTokenValues, LayoutToken, OpacityToken, ZIndexToken };
